import {useEffect, useState} from "react";

import { Box, Flex, SkeletonCircle, SkeletonText } from "@chakra-ui/react";
import { isValidArray } from "../../global/helpers/global-helpers";
import LaunchdeckTextLoader from "../../global/components/helper-components/components/LaunchdeckTextLoader";

export default function NewFeedPostsLoadingDisplay({processingNewDsrPosts}) {
  
  const [loadingPosts, setLoadingPosts] = useState([])
  useEffect(()=> {
    if (Array.isArray(processingNewDsrPosts)) {
      setLoadingPosts(processingNewDsrPosts)
    }
  },[processingNewDsrPosts])

  const loadingPostDisplay = isValidArray(loadingPosts) ? loadingPosts.map((loadingPostId) => { 
    return (
      <Box
      key={loadingPostId}
      w='100%'
      mt='1em' mb='2em' p='1em'
      bg='white'
      rounded='0.25em' border='1px solid rgba(203, 213, 224, 0.5)'
    >
      <Flex width='100%' mb='2em' justify='space-between' align='flex-start'>
        <Flex justify='flex-start' gap='1em'>
          <SkeletonCircle size='3em' />
          <Box w='35%' minW='16em'>
            <SkeletonText mt='3' noOfLines={2} spacing='4' skeletonHeight='0.875em' rounded='0.25em'/>
          </Box>
        </Flex>
        <Flex justify='flex-end' pr='0.5em'>
           <LaunchdeckTextLoader copyText="Updating post" color='gray.500' fontSize='0.7em' postId={loadingPostId}/>
        </Flex>
      </Flex>

      <SkeletonText px='0.5em' pb='0.5em' noOfLines={3} spacing='4' skeletonHeight='0.875em' />
    </Box>
    )
  })

  : null
  return loadingPostDisplay
}